import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=f96a0a68"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=f96a0a68&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96a0a68')) {
      api.createRecord('f96a0a68', component.options)
    } else {
      api.reload('f96a0a68', component.options)
    }
    module.hot.accept("./NewTicket.vue?vue&type=template&id=f96a0a68", function () {
      api.rerender('f96a0a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewTicket.vue"
export default component.exports